import type { Bereich } from '@/core/settings'
import { useSettings } from './settings'
import { MarkeIcon } from './Icons'

export interface EinstiegProps {
  onFertig: (abschnitt: 'quiz' | 'bestimmen') => void
}

/**
 * Der erste Bildschirm, und für viele der einzige, den sie ganz lesen.
 *
 * Vorher stand hier ein Startbildschirm mit vier Kacheln, einer Zählung und einem Knopf
 * "Weiterlernen", und ein Schwarmtest hat gezeigt, was davon ankommt: nichts. "Für wen
 * das ist, steht nirgends." Ein Klick auf den einzigen auffälligen Knopf warf den Besucher
 * in eine Quizfrage mit vier Antworten voller Fachbegriffe.
 *
 * Also eine Frage, drei Antworten, sonst nichts. Die Antwort setzt den Bereich, damit die
 * App von da an den richtigen Stoff zeigt, und sie sagt dem Besucher in einem Satz, wofür
 * die App gut ist. Wer nur nachschlagen will, bekommt genau das und kein Lernprogramm.
 */
const WEGE: {
  id: Bereich | 'nachschlagen'
  bereich: Bereich
  /** Wo der Weg endet. Wer nur nachschlagen will, bekommt kein Quiz. */
  abschnitt: 'quiz' | 'bestimmen'
  titel: string
  sagt: string
}[] = [
  {
    id: 'binnen',
    bereich: 'binnen',
    abschnitt: 'quiz',
    titel: 'einstieg.binnen',
    sagt: 'einstieg.binnen.sagt',
  },
  {
    id: 'see',
    bereich: 'see',
    abschnitt: 'quiz',
    titel: 'einstieg.see',
    sagt: 'einstieg.see.sagt',
  },
  {
    id: 'nachschlagen',
    bereich: 'see',
    abschnitt: 'bestimmen',
    titel: 'einstieg.nachschlagen',
    sagt: 'einstieg.nachschlagen.sagt',
  },
]

export function Einstieg({ onFertig }: EinstiegProps) {
  const { t, update } = useSettings()

  return (
    <section className="einstieg" data-testid="einstieg">
      <h1 className="einstieg__marke">
        <MarkeIcon />
        {t('app.title')}
      </h1>
      <p className="einstieg__was" data-testid="einstieg-was">
        {t('einstieg.was')}
      </p>
      <h2 className="einstieg__frage" data-testid="auftrag">
        {t('einstieg.frage')}
      </h2>
      <div className="einstieg__wege">
        {WEGE.map((weg) => (
          <button
            key={weg.id}
            type="button"
            className="einstieg__weg"
            data-weg={weg.id}
            data-testid={`einstieg-${weg.id}`}
            onClick={() => {
              update({ bereich: weg.bereich, eingerichtet: true })
              onFertig(weg.abschnitt)
            }}
          >
            <span className="einstieg__titel">{t(weg.titel as never)}</span>
            <span className="einstieg__sagt">{t(weg.sagt as never)}</span>
          </button>
        ))}
      </div>
      <p className="einstieg__klein">{t('einstieg.spaeter')}</p>
    </section>
  )
}
